import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';

import merge from '@/utils/merge';

var DefaultWkFileSelectData = {
  name: 'file',
  accept: '*.*',
  multiple: true
};

export default {
  // 附件选择
  name: 'WkFile',

  components: {},

  props: {},

  data: function data() {
    return {
      data: {},
      resolve: null
    };
  },


  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    handleChange: function handleChange(ev) {
      this.resolve(ev);
    },
    select: function select(data) {
      var _this = this;

      this.data = merge(_extends({}, DefaultWkFileSelectData), data || {});
      this.$refs.wkFileInput.value = null;
      this.$refs.wkFileInput.click();
      return new _Promise(function (resolve, reject) {
        _this.resolve = resolve;
      });
    }
  }
};